export { default } from './withNumericRatingIcons';
